<template>
  <section class="content">
    <div class="form-group">
      <div v-for="(option, index) in triggerList" :key="index" class="checkbox">
        <label>
          <input type="checkbox" 
          :value="option.value" 
          :checked="isSelected(option.value)"
          @change="updateSelection(option.value, $event.target.checked)">
          {{ option.label }}
        </label>
      </div>
      <ErrorText name="trigger" :errors="errors"/>
    </div>
  </section>
</template>
<script>
import ErrorText from "../ErrorText";
import applicationSelectItem from "../../mixins/applicationSelectItem";

export default {
  name: "TriggerForm",
  components: {ErrorText},
  mixins: [applicationSelectItem],

  props: {
    value: {
      type: Array,
      default: () => []
    },
    old: {
      type: Array,
      default: () => []
    },
    errors: {
      type: [Object, Array]
    }
  },
  methods: {
    isSelected(value) {
      return (this.old.length ? this.old : this.value).includes(value);
    },
    updateSelection(value, checked) {
      let newValue = [...this.value];
      if (checked) {
        if (!newValue.includes(value)) {
          newValue.push(value);
        }
      } else {
        newValue = newValue.filter(item => item !== value);
      }
      this.$emit('input', newValue);
    }
  }
}
</script>
<style scoped>

</style>